<div class="data-table-header">
  <p *ngIf="title" class="page-title">
    {{ title }}
  </p>

  <div *ngIf="action" class="action-template">
    <ng-container [ngTemplateOutlet]="action"> </ng-container>
  </div>
</div>

<div class="table-container">
  <table class="w-full" aria-labelledby="page-title">
    <thead class="text-left table-head border-split">
      <tr>
        <ng-container *ngIf="header" [ngTemplateOutlet]="header"></ng-container>
      </tr>
    </thead>
    <tbody class="table-body">
      <tr *ngFor="let data of data">
        <ng-container
          [ngTemplateOutletContext]="{ $implicit: data }"
          [ngTemplateOutlet]="body"
        ></ng-container>
      </tr>
    </tbody>
  </table>
</div>
